
const base_url = 'https://www.ebi.ac.uk/pdbe/api';

export default {

  fetchCathBDomainInfo(domid) {
    if (!domid) {
      return new Promise(() => {
        throw new Error("failed to provide domid for fetchCathBDomainInfo");
      });
    }
    const pdbid = domid.substring(0, 4);
    console.log(`fetching CATH-B info for pdb '${pdbid}'`);
    const url = `${base_url}/mappings/cath_b/${pdbid}`;
    const promise = new Promise((resolve, reject) => {
      fetch(url)
        .then(res => res.json())
        .then(response => {
          const assignment_data = response[pdbid]['CATH-B']
          let rep_mappings = [];
          for (var sfam_key in assignment_data) {
            for (var mapping of assignment_data[sfam_key].mappings) {
              if (mapping.domain === domid) {
                rep_mappings.push(mapping);
              }
            }
          }
          if (!rep_mappings) {
            throw new Error(`failed to find any mappings for domain ${domid}: ${url}`);
          }
          rep_mappings = rep_mappings.sort((a, b) => (a.segment_id < b.segment_id) ? 1 : -1);
          const segments = rep_mappings.map((m) => {
            return {
              chain_id: m.chain_id,
              domain_id: m.domain_id,
              segment_id: m.segment_id,
              pdb_start: m.start.author_residue_number + m.start.author_insertion_code,
              pdbe_start: m.start.residue_number,
              pdb_end: m.end.author_residue_number + m.end.author_insertion_code,
              pdbe_end: m.end.residue_number,
            }
          });

          const domain_info = {
            pdb_id: pdbid,
            domain_id: domid,
            segments: segments,
          }

          resolve(domain_info);
        })
    });
    return promise;
  }
}
